import React from "react";

const ModalComp = () => {
  return (
    <div className="flex min-h-screen flex-col align-items justify-center">
      <button className=" mx-auto w-40 bg-gray-400 p-2">Show Modal</button>

      <div className=" bg-white ">Hello this is my modal</div>
    </div>
  );
};

export default ModalComp;
